import { useCallback, useEffect, useRef, useState } from 'react';

import { ROTATION_INTERVAL, TIMER_INTERVAL } from '../constants';

import { TimerProps } from './types';

/**
 * This timer only works when the tab is active
 * @returns timeLeft: number
 */
export const useTimer = (): TimerProps => {
  const [timeLeft, setTimeLeft] = useState<number>(ROTATION_INTERVAL);

  const intervalId = useRef<NodeJS.Timer | undefined>(undefined);

  const clear = useCallback(() => {
    if (intervalId.current) clearInterval(intervalId.current);
  }, []);

  const restart = useCallback(() => {
    clear();
    setTimeLeft(ROTATION_INTERVAL);
    intervalId.current = setInterval(() => {
      setTimeLeft((prevTimeLeft) => {
        if (prevTimeLeft === 0) {
          return ROTATION_INTERVAL;
        }

        return prevTimeLeft - TIMER_INTERVAL;
      });
    }, TIMER_INTERVAL);
  }, [clear]);

  useEffect(() => {
    restart();

    return clear;
  }, [restart, clear]);

  return { timeLeft, restart };
};
